import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MapService} from '../../core/map/map.service';
import {NavigationService} from '../../core/navigation/navigation.service';
import {AuthService} from '../../core/auth/auth.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {AccountsService} from '../../core/accounts/accounts.service';
import {UsersService} from '../../core/users/users.service';
import {Observable} from '../../../../node_modules/rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  @ViewChild('infoTemplate') modalTemplate: TemplateRef<any>;
  @ViewChild('planTemplate') planTemplate: TemplateRef<any>;

  showVisualize: boolean;
  showPlaces: boolean;
  showAccounts: boolean;
  showLayers: boolean;
  showRoutes: boolean;
  showLasso: boolean;

  showReports: boolean;
  showSettings: boolean;

  activeNavItem: string;

  showNav = false;

  showImport = false;

  uploadActive = false;

  loadRoute = false;

  modalRef: BsModalRef;

  sampleButtonLabel="Show sample data";
  sampleButtonDisable=false;


  resetting = false;

  resetForm: FormGroup;

  passphrase = 'Delete All Accounts';

  constructor(private mapService: MapService,
              private navigationService: NavigationService,
              private fb: FormBuilder,
              private modalService: BsModalService,
              private accountsService: AccountsService,
              private usersService: UsersService,
              private authService: AuthService) { }

  ngOnInit() {

    this.resetForm = this.fb.group({
      passphrase: ['', Validators.required]
    });


    this.accountsService.list()
      .subscribe((accounts: any[]) => {
        if (!accounts.length) {
          this.openModal();
        } else {
          this.showNav = true;
        }
      });

    this.navigationService.openRoute.subscribe(navigate => {
      if (navigate) {
        this.toggleRoutes(true);
      }
    });

    this.navigationService.openLasso.subscribe(navigate => {
      if (navigate) {
        this.toggleLasso(true);
      }
    });

    this.authService.logOut.subscribe((doLogout) => {
      if (doLogout) {
        this.showVisualize = false;
        this.showAccounts = false;
        this.showPlaces = false;
        this.showLayers = false;
        this.showRoutes = false;
        this.showLasso = false;
        this.showSettings = false;
        this.showReports = false;
        this.activeNavItem = null;
        this.mapService.toggleExpanded(false);
      }
    });

    this.modalService.onHide.subscribe(() => {
      this.showNav = true;
    });

  }

  toggleVisualize(show: boolean) {
    if (show) {
      this.showVisualize = show;
    } else {
      this.showVisualize = !this.showVisualize;
    }
    if (this.showVisualize) {
      this.showAccounts = false;
      this.showPlaces = false;
      this.showLayers = false;
      this.showRoutes = false;
      this.showLasso = false;
      this.showSettings = false;
      this.showReports = false;
      this.activeNavItem = 'VISUALIZE';
      this.mapService.toggleExpanded(true);
    } else {
      this.activeNavItem = null;
      this.mapService.toggleExpanded(false);
    }
  }

  toggleAccounts(show: boolean) {
    if (show) {
      this.showAccounts = show;
    } else {
      this.showAccounts = !this.showAccounts;
    }
    if (this.showAccounts) {
      this.showVisualize = false;
      this.showPlaces = false;
      this.showLayers = false;
      this.showRoutes = false;
      this.showLasso = false;
      this.showSettings = false;
      this.showReports = false;
      this.activeNavItem = 'ACCOUNTS';
      this.mapService.toggleExpanded(true);
    } else {
      this.activeNavItem = null;
      this.mapService.toggleExpanded(false);
    }
  }

  togglePlaces(show: boolean) {
    if (show) {
      this.showPlaces = show;
    } else {
      this.showPlaces = !this.showPlaces;
    }
    if (this.showPlaces) {
      this.showVisualize = false;
      this.showAccounts = false;
      this.showLayers = false;
      this.showRoutes = false;
      this.showLasso = false;
      this.showSettings = false;
      this.showReports = false;
      this.activeNavItem = 'PLACES';
      this.mapService.toggleExpanded(true);
    } else {
      this.activeNavItem = null;
      this.mapService.toggleExpanded(false);
    }
  }

  toggleLayers(show: boolean) {
    if (show) {
      this.showLayers = show;
    } else {
      this.showLayers = !this.showLayers;
    }
    if (this.showLayers) {
      this.showVisualize = false;
      this.showAccounts = false;
      this.showPlaces = false;
      this.showRoutes = false;
      this.showLasso = false;
      this.showSettings = false;
      this.showReports = false;
      this.activeNavItem = 'LAYERS';
      this.mapService.toggleExpanded(true);
    } else {
      this.activeNavItem = null;
      this.mapService.toggleExpanded(false);
    }
  }

  toggleRoutes(show: boolean) {
    if (show) {
      this.showRoutes = show;
    } else {
      this.showRoutes = !this.showRoutes;
    }
    if (this.showRoutes) {
      this.showVisualize = false;
      this.showAccounts = false;
      this.showPlaces = false;
      this.showLayers = false;
      this.showLasso = false;
      this.showSettings = false;
      this.showReports = false;
      this.activeNavItem = 'ROUTES';
      this.mapService.toggleExpanded(true);
    } else {
      this.activeNavItem = null;
      this.mapService.toggleExpanded(false);
    }
  }

  toggleLasso(show: boolean) {
    if (show) {
      this.showLasso = show;
    } else {
      this.showLasso = !this.showLasso;
    }
    if (this.showLasso) {
      this.showVisualize = false;
      this.showAccounts = false;
      this.showPlaces = false;
      this.showLayers = false;
      this.showRoutes = false;
      this.showSettings = false;
      this.showReports = false;
      this.activeNavItem = 'LASSO';
      this.mapService.toggleExpanded(true);
    } else {
      this.activeNavItem = null;
      this.mapService.toggleExpanded(false);
    }
  }

  toggleReports(show: boolean) {
    if (show) {
      this.showReports = show;
    } else {
      this.showReports = !this.showReports;
    }
    if (this.showReports) {
      this.showVisualize = false;
      this.showAccounts = false;
      this.showPlaces = false;
      this.showLayers = false;
      this.showRoutes = false;
      this.showLasso = false;
      this.showSettings = false;
      this.activeNavItem = 'REPORTS';
      this.mapService.toggleExpanded(true);
    } else {
      this.activeNavItem = null;
      this.mapService.toggleExpanded(false);
    }
  }

  toggleSettings(show: boolean) {
    if (show) {
      this.showSettings = show;
    } else {
      this.showSettings = !this.showSettings;
    }
    if (this.showSettings) {
      this.showVisualize = false;
      this.showAccounts = false;
      this.showPlaces = false;
      this.showLayers = false;
      this.showRoutes = false;
      this.showLasso = false;
      this.showReports = false;
      this.activeNavItem = 'SETTINGS';
      this.mapService.toggleExpanded(true);
    } else {
      this.activeNavItem = null;
      this.mapService.toggleExpanded(false);
    }
  }

  isActive(navItem: string) {
    return navItem === this.activeNavItem;
  }

  openModal() {
    this.modalRef = this.modalService.show(this.modalTemplate);
  }

  closeModal(e) {
    this.modalRef.hide();
    if (e) {
      e.preventDefault();
    }
  }

  disableInfo() {
    this.usersService.edit(this.authService.getProfile()._id, {showIntro: false})
      .subscribe((profile) => {
        this.modalRef.hide();
        this.authService.setProfile(profile);
      }, (err) => {
        alert(err.error.message || 'An error occurred');
      });
  }

  loadSample() {
    this.sampleButtonLabel="Loading....";
    this.sampleButtonDisable=true;
    this.authService.populate()
      .subscribe(() => {
        this.sampleButtonLabel="Show sample data";
        this.sampleButtonDisable=false;
        this.loadRoute = true;
        this.modalRef.hide();
      }, (err) => {
        this.sampleButtonLabel="Show sample data";
        this.sampleButtonDisable=false;
        alert(err.error.message || 'An error occurred');
      });
  }

  onUploadAccounts(accountRows) {
    const accounts = accountRows.map(ar => ({
      name: ar.Name,
      address: ar.Address,
      phone: ar.Phone,
      email: ar.Email,
      website: ar.Website
    }));

    this.uploadActive = true;

    Observable.forkJoin(accounts.filter(a => a.address).map((a, i) => this.findPlace(a, i))).subscribe(accountsWithPlace => {
      this.accountsService.bulkCreate(accountsWithPlace.filter(a => a))
        .subscribe(() => {
          this.uploadActive = false;
          this.modalRef.hide();
        });
    });
  }

  findPlace(account, index) {
    return new Observable((observer) => {
      const geocoder = new google.maps.Geocoder;

      setTimeout(() => {
        geocoder.geocode({ address: account.address, componentRestrictions: { country: 'US'} }, (results, status) => {
          if (results && results.length) {
            const place = results[0];
            account.placeId = place.place_id;
            account.coords = [place.geometry.location.lng(), place.geometry.location.lat()];

            this.mapService.placesSearchService.getDetails({placeId: place.place_id, fields: ['opening_hours']}, (result, st) => {
              if (result && result.opening_hours) {
                account.notes = result.opening_hours.weekday_text.join('\n');
              }
              observer.next(account);
              observer.complete();
            });
          } else {
            observer.next(null);
            observer.complete();
          }
        });
      }, 1000 * index);
    });
  }

  isTrialPlan() {
    return this.authService.isTrialPlan();
  }

  getDaysLeft() {
    return this.authService.getDaysLeft();
  }

  buyPlan() {
    this.modalRef = this.modalService.show(this.planTemplate, {class: 'modal-lg'});
  }

  openResetModal(e, template: TemplateRef<any>, options?) {
    this.modalRef = this.modalService.show(template, options ||{ class: 'modal-lg ' });
    e.preventDefault();
  }

  resetEnabled() {
    return this.resetForm.valid && this.passphrase.toUpperCase() === this.resetForm.controls['passphrase'].value.toString().toUpperCase();
  }
  reset() {
    this.resetting = true;
    this.authService.reset()
      .subscribe(() => {
        window.location.reload();
      }, (err) => {
        this.resetting = false;
        alert(err.error.message || 'An error occurred');
      });
  }
}



// WEBPACK FOOTER //
// ./client/app/components/main/main.component.ts